import TokenService from '@/helpers/token';
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import store from "@/store";
import router from "@/router";
import {Logger} from "sass";

const baseUrl = process.env.VUE_APP_API_URL;
const options = {
    baseURL: baseUrl,
    headers: {},
};
const axiosInstance = axios.create(options);
axiosInstance.interceptors.request.use(async (request: AxiosRequestConfig) => {
    Object.assign(request?.headers, {
        'X-LANG': TokenService.getLang() || 'vi',
    });

    return request;
});
axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        let fe_version = process.env?.VUE_APP_VERSION?.toString() || 'default'
        if(fe_version !== localStorage.getItem('fe-version') && response.config.method == 'get'){
            // window.navigator.serviceWorker.getRegistrations()
            //     .then(registrations => {
            //         for(let registration of registrations) {
            //             registration.unregister();
            //         }
            //     });
            var result = false;
            if (window.caches != null) {
                caches.keys().then(cacheNames => {
                    cacheNames.forEach(cacheName => {
                        caches.delete(cacheName).then(function(response) {
                            result = true;
                        });
                    });
                });
            }
            localStorage.clear()
            localStorage.setItem('fe-version', fe_version)
            window.location.reload() // For new version, simply reload on any get
        }
            const res = response.data
            res.success = response?.data?.status_code === 200;
            if (res.status_code !== 200) {
                console.log(res)
                if (res.status_code === 422) {
                    return res
                }
                if (res.status_code === 401) {
                    store.dispatch('auth/logOut')
                    router.push({ name: 'LoginPage' })
                }
                if (res.status_code === 404) {
                    router.push({ name: 'Error404Page' })
                }
                if (res.status_code === 500) {
                    router.push({ name: 'Error500Page' })
                }
                return Promise.reject(new Error(res.message || 'Error'))
            } else {
                res.success = response?.data?.status_code === 200;
                return res
            }
        },
        //

    async (error) => {
        if (error.response) {
            error.response.data = {
                ...(error?.response?.data || {}),
                success: false,
            };
            return error.response?.data; // simply return the response's data
        } else if (error.request) {
            error.request.data = {
                ...(error?.request?.data || {}),
                success: false,
                isRequestError: true,
                message: error.message,
            };
            return error.request?.data;
        }
    },
);

export default axiosInstance;
